
import React from "react";
import { STORAGE_URL } from "@/lib/supabase";
import { KitLogo } from "@/hooks/useKitLogo";

interface LogoSectionProps {
  logo?: KitLogo | null;
}

export const LogoSection: React.FC<LogoSectionProps> = ({ logo }) => {
  return (
    <div className="w-[350px] h-full bg-black flex items-center justify-center shrink-0">
      {logo?.storage_path ? (
        <img
          src={`${STORAGE_URL}/storage/v1/object/public/logos/${logo.storage_path}`}
          alt="Logo"
          className="h-full w-full object-contain p-2"
          onError={(e) => {
            console.error("Error loading logo image");
            // Set to fallback image on error
            e.currentTarget.src = "/lovable-uploads/2c14eb56-5fdf-4b45-a67f-c187507cd4d9.png";
          }}
        />
      ) : (
        <img
          src="/lovable-uploads/2c14eb56-5fdf-4b45-a67f-c187507cd4d9.png"
          alt="Logo"
          className="h-full w-full object-contain p-2"
        />
      )}
    </div>
  );
};
